module.exports = __webpack_public_path__ + "static/media/top7.6a884375.wav";